import { render } from "./CreateOffice.vue?vue&type=template&id=492b42d2"
import script from "./CreateOffice.vue?vue&type=script&lang=js"
export * from "./CreateOffice.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Amaze-Portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__